"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "13",
  r: "1"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "13",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "m8.33 7.5-.66 2h8.66l-.66-2z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M22 2H2v20h20zm-3 16.5h-2v-2H7v2H5v-7.31L6.89 5.5H17.1l1.9 5.69z"
}, "3")], 'GarageSharp');